import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-thank-you-login-page',
  templateUrl: './thank-you-login-page.component.html',
  styleUrls: ['./thank-you-login-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThankYouLoginPageComponent {
}
